import type { PageState } from './types'

export const selectPageItem = (state: { page: PageState }) => state.page
